window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


import Cookies from 'js-cookie';
window.Cookies = Cookies;

import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);

window.Chart = Chart;
import {
    ClassicEditor,
    AccessibilityHelp,
    Alignment,
    Autoformat,
    AutoImage,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    Code,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    ImageBlock,
    ImageCaption,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    MediaEmbed,
    Mention,
    PageBreak,
    Paragraph,
    PasteFromOffice,
    RemoveFormat,
    SelectAll,
    SimpleUploadAdapter,
    SourceEditing,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
    Undo
} from 'ckeditor5';

window.ClassicEditor = ClassicEditor;
window.AccessibilityHelp = AccessibilityHelp;
window.Alignment = Alignment;
window.Autoformat = Autoformat;
window.AutoImage = AutoImage;
window.AutoLink = AutoLink;
window.Autosave = Autosave;
window.BlockQuote = BlockQuote;
window.Bold = Bold;
window.Code = Code;
window.Essentials = Essentials;
window.FindAndReplace = FindAndReplace;
window.FontBackgroundColor = FontBackgroundColor;
window.FontColor = FontColor;
window.FontFamily = FontFamily;
window.FontSize = FontSize;
window.GeneralHtmlSupport = GeneralHtmlSupport;
window.Heading = Heading;
window.Highlight = Highlight;
window.HorizontalLine = HorizontalLine;
window.HtmlComment = HtmlComment;
window.HtmlEmbed = HtmlEmbed;
window.ImageBlock = ImageBlock;
window.ImageCaption = ImageCaption;
window.ImageInline = ImageInline;
window.ImageInsert = ImageInsert;
window.ImageInsertViaUrl = ImageInsertViaUrl;
window.ImageResize = ImageResize;
window.ImageStyle = ImageStyle;
window.ImageTextAlternative = ImageTextAlternative;
window.ImageToolbar = ImageToolbar;
window.ImageUpload = ImageUpload;
window.Indent = Indent;
window.IndentBlock = IndentBlock;
window.Italic = Italic;
window.Link = Link;
window.LinkImage = LinkImage;
window.List = List;
window.ListProperties = ListProperties;
window.MediaEmbed = MediaEmbed;
window.Mention = Mention;
window.PageBreak = PageBreak;
window.Paragraph = Paragraph;
window.PasteFromOffice = PasteFromOffice;
window.RemoveFormat = RemoveFormat;
window.SelectAll = SelectAll;
window.SimpleUploadAdapter = SimpleUploadAdapter;
window.SourceEditing = SourceEditing;
window.SpecialCharacters = SpecialCharacters;
window.SpecialCharactersArrows = SpecialCharactersArrows;
window.SpecialCharactersCurrency = SpecialCharactersCurrency;
window.SpecialCharactersEssentials = SpecialCharactersEssentials;
window.SpecialCharactersLatin = SpecialCharactersLatin;
window.SpecialCharactersMathematical = SpecialCharactersMathematical;
window.SpecialCharactersText = SpecialCharactersText;
window.Strikethrough = Strikethrough;
window.Style = Style;
window.Subscript = Subscript;
window.Superscript = Superscript;
window.Table = Table;
window.TableCaption = TableCaption;
window.TableCellProperties = TableCellProperties;
window.TableColumnResize = TableColumnResize;
window.TableProperties = TableProperties;
window.TableToolbar = TableToolbar;
window.TextTransformation = TextTransformation;
window.TodoList = TodoList;
window.Underline = Underline;
window.Undo = Undo;

import './echo';
